import request from '@/utils/requestYkp';
import { ApiPrefix } from '@/constants/constants';

// 获取人员列表
export const queryKpqxList = (data: any) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/kpqx/queryKpqxList.do',
		method: 'POST',
		data,
	});
};
// 获取集团组织机构
export const queryOrgList = (data: any) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/kpqx/queryOrgTreeList.do',
		method: 'POST',
		data,
	});
};
// 保存开票权限设置
export const saveKpqx = (data: any) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/kpqx/saveKpqx.do',
		method: 'POST',
		data,
	});
};
// 查询关联企业
export const queryQyList = (data: any) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/kpqx/queryQyList.do',
		method: 'POST',
		data,
	});
};
// 查询关联企业
export const getDetail = (data: any) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/kpqx/detail.do',
		method: 'POST',
		data,
	});
};
// 删除开票权限
export const deleteKpqx = (data: any) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/kpqx/deleteKpqx.do',
		method: 'GET',
		params: data,
	});
};
